('use strict');
import 'vendor/jquery.isOnScreen';
import debounce from 'lodash/debounce';
import { isPageAvailableForTracking, hasImpressionTracking } from 'shared/impressionTracking';

export default class GridImpressionTracking {
    constructor(wrappers, viewEventName, clickEventName, trackingObject = null, delay = 2000) {
        this.wrappers = wrappers;
        this.viewEventName = viewEventName;
        this.clickEventName = clickEventName;
        this.trackingObject = trackingObject;
        this.currentUri = String(window.location.href);

        this.isFeatureHub = viewEventName === 'carouselView' && clickEventName === 'carouselSelect';

        this.targets = this.findTargets();

        this.delay = delay;

        this.debounceCallback = debounce(this.debounceHandler, this.delay);

        this.addEvents();

        this.track(this.viewEventName);
    }

    findTargets() {
        let targets = this.wrappers
            .map((element) => {
                let attr = element.getAttribute('class').trim().replace(/\s/g, '.') + ' ' + 'a';
                return `.${attr}`;
            })
            .join(', ');

        return targets;
    }

    addEvents() {
        window.addEventListener('scroll', this.debounceCallback);
        window.addEventListener('resize', this.debounceCallback);
        if (this.targets.length) {
            $(document).on('click', `${this.targets}`, this.clickHandler);
        }
    }

    debounceHandler = () => {
        this.track(this.viewEventName);
    };

    removeEvents() {
        window.removeEventListener('scroll', this.debounceCallback);
        window.removeEventListener('resize', this.debounceCallback);
        $(document).off('click', `${this.targets}`, this.clickHandler);
    }

    clickHandler = (event) => {
        let currentTarget = event.currentTarget;
        this.track(this.clickEventName, currentTarget);
    };

    track = (event, item = null) => {
        let wrappersOnScreen = this.wrappers
            .filter((element) => {
                if (!item) {
                    return $(element).isOnScreen(1, 1, true, true);
                }

                return (
                    $(element).isOnScreen(1, 1, true, true) &&
                    $(item).isOnScreen(1, 1, true, true) &&
                    element.contains(item)
                );
            })
            .map((element) => this.buildPayload(element, item))
            .filter((element) => element != null);

        let objTracking = this.buildPayObject(wrappersOnScreen);

        this.trackObject(objTracking, event);
    };

    trackObject(obj, eventType) {
        if (!this.suppressTracking() && typeof om != 'undefined') {
            let eventData = {
                type: eventType,
                data: {
                    ...(this.isFeatureHub && {
                        feature: this.buildDataFeatureObject(),
                    }),
                    pplus: obj,
                },
            };

            if (typeof om != 'undefined') {
                om.sendEvent(eventData);
            }
        }
    }

    buildPayload(container, item = null) {
        let data = container.dataset;
        let items = item ? [item] : Array.from(container.querySelectorAll('a'));
        items = items.filter((element) => {
            if (item) {
                return $(element).isOnScreen(1, 1, true, true);
            }
            return $(element).isOnScreen(1, 1, false, true);
        });

        let itemPayload = this.buildItemsPayload(items);

        if (!itemPayload.length) {
            return null;
        }

        const payload = {
            containerId: data.id ?? '',
            containerTitle: data.title ?? '',
            containerType: data.type ?? data.id ?? '',
            displayId: data.displayid ?? '',
            rowNum: data?.position ? Number(data.position) : '0',
            isHighlightEnabled: data.iscontenthighlightenabled ? 'true' : 'false',
            containerStyle: data.presentationstyle ?? '',
            rankModel: '',
            pvrModel: '',
            items: itemPayload,
        };

        return payload;
    }

    buildItemsPayload(items) {
        let resultItems = items.map((element) => {
            let dataImpression = element.dataset.impression.split('|');
            let [id, title, type, position, badgeLabel, locked, cmsId] = dataImpression;
            let spotlightItem = {};

            // add extra params for spotlight carousel
            if (dataImpression[4] == 'spotlight') {
                spotlightItem = {
                    streamStartTimestamp: dataImpression[13]?.toString() ?? '',
                    streamEndTimestamp: dataImpression[14]?.toString() ?? '',
                    videoId: dataImpression[12]?.toString() ?? '',
                    contentStatus: dataImpression[15]?.toString() ?? '',
                    type,
                    isUnlocked: '',
                };
            }

            return {
                id,
                title,
                type,
                position,
                badgeLabel,
                isUnlocked: !(locked === '1'),
                cmsId,
                ...spotlightItem,
            };
        });

        return resultItems;
    }

    buildDataFeatureObject() {
        return {
            hub: [
                {
                    id: CBS.Tracking?.utag_data?.hubId?.toString() ?? '',
                    slug: CBS.Tracking?.utag_data?.hubSlug?.toString() ?? '',
                    title: CBS.Tracking?.utag_data?.title?.toString() ?? '',
                },
            ],
        };
    }

    buildPayObject(payObject) {
        // for no results case, or cases where there are carousels present
        // use existing carousel impression tracking and add the payload to this grid call
        if (window.impressionTracking.track !== null) {
            payObject = payObject.concat(window.impressionTracking.track.getVisibleWrappers());
        }

        let obj = {
            brandPlatformId: CBS.Registry?.brandPlatformID?.toString(),
            siteEdition: CBS.Registry?.siteEdition?.toString(),
            optimizelyExp: CBS.Tracking?.utag_data?.optimizelyExp,
            pageViewGuid: CBS.Tracking?.utag_data?.pageViewGuid,
            userRegId: CBS.Registry?.user?.id?.toString() ?? '',
            userBundle: CBS.Registry?.user?.bundleStatus?.toString() ?? '',
            userStatus: CBS.Registry?.user?.sb?.toString() ?? '',
            userType: CBS.Registry?.user?.sub_status?.toString() ?? '',
            userClientRegion: CBS.Registry?.region?.property?.toString() ?? '',
            userProfileId: CBS.Registry?.user?.profile_id?.toString() ?? '',
            userProfileCategory: CBS.Registry?.user?.profile_type?.toString() ?? '',
            userProfileMaster: CBS.Registry?.user?.userProfileMaster?.toString() ?? '',
            userProfileRefId: CBS.Registry?.user?.profile_reference_id?.toString() ?? '',
            contentFeatures: payObject,
            ...this.trackingObject,
        };

        return obj;
    }

    suppressTracking() {
        let profile_type = CBS.Registry?.user?.profile_type?.toString() ?? '';

        return profile_type != 'ADULT' || window.location.href.includes('user-profile');
    }
}

/**
 * Checking if CBS.Registry.pageType or window.location.href are available for Tracking
 * @param {object[]} pageList - [{pageType: 'HOMEPAGE', href: '/home'}]
 * @return {boolean}
 */
export const isGridPageAvailableForTracking = (pageList = null) =>
    isPageAvailableForTracking(pageList);

export const hasGridImpressionTracking = (
    isFathomHost = false,
    isAvailableForTracking = isGridPageAvailableForTracking,
) => hasImpressionTracking(isFathomHost, isAvailableForTracking);
